module.exports = __webpack_public_path__ + "static/media/login-image.7f8890a1.png";